import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { adminService } from "../services/api";
import "./Header.css";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const [headerBanner, setHeaderBanner] = useState("");

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const settings = await adminService.getSettings();
        if (settings && settings.header_banner) {
          setHeaderBanner(settings.header_banner);
        }
      } catch (error) {
        console.error("Error fetching header banner:", error);
      }
    };
    fetchBanner();
  }, []);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActive = (path) => {
    if (path === "/home") {
      return (
        location.pathname === "/home" ||
        location.pathname.startsWith("/vehicle/")
      );
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      {/* Background Banner Image for Header */}
      <div
        className="header-bg-banner"
        style={{
          backgroundImage:
            headerBanner ?
              `url(${headerBanner})`
            : 'url("https://images.unsplash.com/photo-1616423640778-28d1b53229bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
        }}
      ></div>

      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <div className="logo-wrapper">
              <img
                src="/logo-placeholder.png"
                alt="XEVF.VN"
                className="logo-img"
                style={{ maxHeight: "40px", width: "auto" }}
              />
              <span className="logo-text">XEVF.VN</span>
              <div className="logo-shine"></div>
            </div>
          </Link>

          {/* Hamburger Menu Icon */}
          <div
            className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          {/* Desktop & Mobile Navigation */}
          <nav className={`nav-menu ${isMobileMenuOpen ? "open" : ""}`}>
            <Link
              to="/home"
              className={`nav-link ${isActive("/home") ? "active" : ""}`}
            >
              Các dòng xe VF
            </Link>
            <Link
              to="/compare"
              className={`nav-link ${isActive("/compare") ? "active" : ""}`}
            >
              So sánh xe
            </Link>
            <Link
              to="/mua-xe-gia-tot"
              className={`nav-link ${isActive("/mua-xe-gia-tot") ? "active" : ""}`}
            >
              Mua Xe Giá Tốt
            </Link>
            <Link
              to="/huong-dan-mua-xe"
              className={`nav-link ${isActive("/huong-dan-mua-xe") ? "active" : ""}`}
            >
              Hướng Dẫn Mua Xe
            </Link>
            <Link
              to="/booking"
              className={`nav-link btn btn-header-cta ${isActive("/booking") ? "active" : ""}`}
            >
              <span className="cta-text">Liên Hệ Sale</span>
            </Link>
          </nav>
        </div>
      </div>

      {/* Overlay for mobile menu */}
      <div
        className={`mobile-overlay ${isMobileMenuOpen ? "show" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>
    </header>
  );
};

export default Header;
